// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){

	//Prevent actions on clicks of top-level menu items on wide screens (mobile is already being handled above)
	$('.has-mega-menu a[href=\\#]').click(function(e) {
		e.preventDefault();
	});


// Top Menu

	$(".secondary .menu-item-has-children > a").click(function(e) {
		subMainNav();
	});

	function subMainNav() {
		// $("nav.secondary-navigation .sub-menu").toggleClass("open");
		$("nav.secondary-navigation .menu-item-has-children").toggleClass("active");
	}

	$('.mega-menu').hover(function() {
	 	
	 	$(this).parents('.has-mega-menu').toggleClass("mega-chevron");
	});



})(jQuery);


// Mobile Menus

var menu = new MmenuLight(
	document.querySelector( '#mobile-navigation' )
);

var navigator = menu.navigation({
	// selectedClass: 'Selected',
	slidingSubmenus: false,
	// theme: 'dark',
	// title: 'Menu'
});

var drawer = menu.offcanvas({
	position: 'right'
});

//	Open the menu.
document.querySelector( 'a[href="#mobile-navigation"]' )
	.addEventListener( 'click', evnt => {
		evnt.preventDefault();
		history.pushState({}, '', this.href);
		drawer.open();
});

